export const EmiStatus = {
  1: "Un paid",
  2: "Paid",
  3: "Partially Paid",
  4: "Overdue Paid",
  5: "Overdue",
  6: "Paused",
  7: "Mandate In Progress",
  8: "Pre Paid",
  9: "Pre closed",
  10: "Refund",
  11: "Settled",
  12: "Written Off",
} as const

export const LoanStatus: any = {
  1: "Active",
  2: "Closed",
  3: "Overdue",
  4: "Written Off",
  5: "Mandate Active",
  6: "Refund",
  7: "Paused",
  8: "Legal",
  9: "Settled",
  10: "OptedOut",
  11: "WrittenOff-Closed",
  12: "Settled-Closed"
} as const

export const MandateStatus = {
  NotInitiated: 1,
  Initiated: 2,
  Partial: 3,
  Successful: 4,
  Rejected: 5,
  DigioUpiMandateSuccessful: 11,
  DigioEmandateSuccessful: 14,
  DigioAadhaarMandate: 15,
  DigioUpiMandate: 16,
  EmandateAuthSuccess: 18,
}

export const AgreementStatus = {
  NotInitiated: 1,
  Initiated: 2,
  Signed: 3,
  Pending: 4,
  InvalidSignature: 5,
  Regenerate: 6,
  PendingCoapplicant: 7,
  Skip: 10,
  Manual: 9,
}

export const SelfieStatus = {
  NotInitiated: 1,
  Initiated: 2,
  Successful: 3,
  Failed: 4,
  Mismatch: 5,
}

export const DigilockerStatus = {
  NotInitiated: 1,
  Initiated: 2,
  Successful: 3,
  Failed: 4,
  Alert: 5,
  Skip: 6,
}
